module.exports = __webpack_public_path__ + "img/Headband_fr.330356ed.jpg";